import { AskPCOSUserType } from "../types"

const syncProfileWithSessionStorage = (userProfile: AskPCOSUserType) => {
  if (!window) return
  window.sessionStorage.setItem("userData", JSON.stringify(userProfile))
}

export default syncProfileWithSessionStorage
